appSocial.service('LeadersSearchService', [
    '$rootScope', 'SocialTypes', 'SocialConstants', 'SocialLocaleService',
    function ($rootScope, SocialTypes, SocialConstants, SocialLocaleService) {

        const {FieldOperation, Op} = SocialTypes;

        class LeadersSearchService {
            constructor() {
                this.constants = SocialConstants;
                this.translation = SocialLocaleService.translation;
                this.$rootScope = $rootScope;

                this.defaultSearch = {
                    country: [],
                    risk: null,
                    market: [],
                    trade: null,
                    tradeSize: null,
                    minGain: null,
                    dateRange: {id: 'thisTwoYears', label: this.translation['thisTwoYears']},
                };
                this.search = _.cloneDeep(this.defaultSearch);
                this.order = 'desc';
                this.customSearch = {};
            }

            reset() {
                this.search = _.cloneDeep(this.defaultSearch);
                this.$rootScope.$emit('LeadersSearchService.reset')
            }

            get() {
                return _.cloneDeep(this.search);
            }

            resetCustomSearch() {
                this.customSearch = null;
            }

            createFields(limit = 20, page = 0) {
                return this.convertToFields(limit, page);
            }

            updateSearch() {
                this.$rootScope.$emit('LeadersSearchService.change')
            }

            saveSearch() {
                this.customSearch = _.cloneDeep(this.search);
            }

            restoreSearch() {
                if (this.customSearch) {
                    this.search.country = this.customSearch.country;
                    this.search.risk = this.customSearch.risk;
                    this.search.market = this.customSearch.market;
                    this.search.trade = this.customSearch.trade;
                    this.search.tradeSize = this.customSearch.tradeSize;
                    this.search.minGain = this.customSearch.minGain;
                    this.search.dateRange = this.customSearch.dateRange;
                }
            }

            convertToFields(limit, page) {
                const filter = {
                    fields: [],
                    order: [],
                    limit: limit,
                    page: page,
                    dateRange: 'all'
                };

                const countries = this.search.country.map(item => {
                    return {
                        name: 'country',
                        op: FieldOperation.Match,
                        value: item.code,
                        next: Op.Or
                    };
                });
                if (countries.length) {
                    //update last item's 'next' operation to 'AND'
                    countries[countries.length - 1].next = Op.And;
                    filter.fields = _.concat(filter.fields, countries);
                }

                const markets = this.search.market.map(item => {
                    return {
                        name: 'markets',
                        op: FieldOperation.Match,
                        value: item.id,
                        next: Op.Or
                    };
                });
                if (markets.length) {
                    //update last item's 'next' operation to 'AND'
                    markets[markets.length - 1].next = Op.And;
                    filter.fields = _.concat(filter.fields, markets);
                }

                if (this.search.minGain !== null) {
                    const gain = {
                        name: 'gain',
                        op: FieldOperation.GreaterThan,
                        value: Number(this.search.minGain) / 100,
                        next: Op.And
                    };

                    filter.fields.push(gain);
                }

                if (this.search.risk) {
                    const riskFrom = {
                        name: 'risk_score',
                        op: FieldOperation.GreaterEqual,
                        value: this.search.risk.range[0],
                        next: Op.And
                    };
                    const riskTo = {
                        name: 'risk_score',
                        op: FieldOperation.LessThan,
                        value: this.search.risk.range[1],
                        next: Op.And
                    };

                    filter.fields = _.concat(filter.fields, [riskFrom, riskTo]);
                }

                if (this.search.trade) {
                    const tradeFrom = {
                        name: 'trades_count',
                        op: FieldOperation.GreaterEqual,
                        value: this.search.trade.range[0],
                        next: Op.And
                    };
                    const tradeTo = {
                        name: 'trades_count',
                        op: FieldOperation.LessThan,
                        value: this.search.trade.range[1],
                        next: Op.And
                    };

                    filter.fields = _.concat(filter.fields, [tradeFrom, tradeTo]);
                }

                if (this.search.tradeSize) {
                    const tradeFrom = {
                        name: 'avg_trade_length',
                        op: FieldOperation.GreaterEqual,
                        value: this.search.tradeSize.range[0],
                        next: Op.And
                    };
                    const tradeTo = {
                        name: 'avg_trade_length',
                        op: FieldOperation.LessThan,
                        value: this.search.tradeSize.range[1],
                        next: Op.And
                    };

                    filter.fields = _.concat(filter.fields, [tradeFrom, tradeTo]);
                }

                if (this.search.dateRange) {
                    filter.dateRange = this.search.dateRange.id;
                }

                return filter;
            }
        }

        return new LeadersSearchService()
    }]);
